import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import RadioGroup from 'components/Form/RadioGroup';
import Radio from 'components/Form/Radio';
import Show from 'components/Form/Show';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import {
  CommonOnUpdate, CommonOnError, CommonRequired, CommonScrollIntoView
} from 'types/props';
import { ErrorCode } from '@redux/modules/application/reducers/error';
import { SubstanceDrugsDrugTypeModel } from 'forms/sections/substance/shared/DrugType';
import { isPVQForm } from 'helpers/form';
import CheckboxGroup from 'components/Form/CheckboxGroup';
import Checkbox from 'components/Form/Checkbox';
import { CheckboxGroupModel, CheckboxModel } from 'forms/shared/types';

interface Props extends ValidationElementProps, Partial<CheckboxGroupModel> {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  scrollIntoView?: CommonScrollIntoView
  attribute?: string
  formType?: string
}

export default class DrugTypes extends ValidationElement<Props> {
  update = (values: Partial<CheckboxGroupModel>) => {
    if (this.props.onUpdate) {
      this.props.onUpdate({
        values: this.props.values,
        ...values,
      });
    }
  };

  getDrugTypes = (cb: CheckboxModel) => {
    const selected = cb.value;
    let list = [...(this.props.values || [])];

    if (list.includes(selected)) {
      list.splice(list.indexOf(selected), 1);
    } else if (selected === 'None' || list.includes('None')) {
      list = [selected];
    } else {
      list.push(selected);
    }
    return list;
  };

  updateDrugTypes = (cb: CheckboxModel) => {
    this.update({
      values: this.getDrugTypes(cb)
    });
  };

  render() {
    return (
      <div className="drug-type">
        <CheckboxGroup
          attribute={this.props.attribute}
          className="option-list option-list-vertical"
          onError={this.props.onError}
          required={this.props.required}
          selectedValues={this.props.values}
        >
          <Checkbox
            className="cocaine"
            label={i18n.t('substance.pvq.drugs.drugType.label.cocaine')}
            value="Cocaine"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
          <Checkbox
            className="stimulants"
            label={i18n.t('substance.pvq.drugs.drugType.label.stimulants')}
            value="Stimulants"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
          <Checkbox
            className="depressants"
            label={i18n.t('substance.pvq.drugs.drugType.label.depressants')}
            value="Depressants"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
          <Checkbox
            className="ketamine"
            label={i18n.t('substance.pvq.drugs.drugType.label.ketamine')}
            value="Ketamine"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
          <Checkbox
            className="narcotics"
            label={i18n.t('substance.pvq.drugs.drugType.label.narcotics')}
            value="Narcotics"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
          <Checkbox
            className="hallucinogenic"
            label={i18n.t('substance.pvq.drugs.drugType.label.hallucinogenic')}
            value="Hallucinogenic"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
          <Checkbox
            className="steroids"
            label={i18n.t('substance.pvq.drugs.drugType.label.steroids')}
            value="Steroids"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
          <Checkbox
            className="inhalants"
            label={i18n.t('substance.pvq.drugs.drugType.label.inhalants')}
            value="Inhalants"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
          <Checkbox
            className="other"
            label={i18n.t('substance.pvq.drugs.drugType.label.other')}
            value="Other"
            onUpdate={this.updateDrugTypes}
            onError={this.props.onError}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
          />
        </CheckboxGroup>
      </div>

    );
  }
}

DrugTypes.defaultProps = {
  values: [],
  onError: (value, arr: ErrorCode[]) => arr,
  formType: '',
};
